<div class="container">
  <!-- <div class="box">

		<div (click)="quickAction(0)" class="btn">
			<div class="imagen">
				<img src="/assets/icons/quick-change-icon.svg" alt="quick change">
			</div>
			<p>Cambio simple</p>
		</div>

		<div (click)="quickAction(1)" class="btn disappear-mobile" [class.proximamente]="!auth.loggedUser.isOperational">
			<div class="imagen">
				<img src="/assets/icons/advanced-change-icon.svg" alt="advanced change">
			</div>
			<p>Cambio avanzado</p>
		</div>
		
		<div (click)="quickAction(2)" class="btn">
			<div class="imagen"></div>
			<p>Invertir dinero</p>
		</div>

		<div (click)="quickAction(3)" class="btn">
			<div class="imagen">
				<img src="/assets/icons/discount-icon.svg" alt="discount">
			</div>
			<p>Referidos</p>
		</div>

		<div (click)="quickAction(4)" class="btn">
			<div class="imagen">
				<img src="/assets/icons/profile-icon.svg" alt="profile">
			</div>
			<p>Modificar perfil</p>
		</div>

	</div> -->

  <div class="body">
    <div class="header">
      <div (click)="pageNumber = 0" class="title">
        <div class="number-box" [class.active]="pageNumber == 0">
          <p class="number active">1</p>
        </div>
        <div class="line border-left" [class.active]="pageNumber == 0"></div>
        <p class="card-title subtitle nm" [class.active]="pageNumber == 0">Transferir</p>
      </div>

      <div (click)="pageNumber = 1" class="title">
        <div class="number-box" [class.active]="pageNumber == 1"><p class="number">2</p></div>
        <div class="line" [class.active]="pageNumber == 1"></div>
        <p class="card-title subtitle nm" [class.active]="pageNumber == 1">Cambiar</p>
      </div>

      <div (click)="pageNumber = 2" class="title">
        <div class="number-box" [class.active]="pageNumber == 2"><p class="number">3</p></div>
        <div class="line border-right" [class.active]="pageNumber == 2"></div>
        <p class="card-title subtitle nm" [class.active]="pageNumber == 2">Retirar</p>
      </div>
    </div>

    <div class="lil-line"></div>

    <div class="viewer" [ngSwitch]="pageNumber">
      <div *ngSwitchCase="0">
        <app-deposit-tab></app-deposit-tab>
      </div>
      <!-- <div *ngSwitchCase="1">
        <app-change-tab></app-change-tab>
      </div> -->

      <div *ngSwitchCase="2">
        <app-withdraw-tab></app-withdraw-tab>
      </div>

      <div *ngSwitchDefault><app-deposit-tab></app-deposit-tab></div>
    </div>
  </div>
</div>
